export const state = {
  serviceGroupName: '',
  services: [],
  vehicles: [],
  add: {
    services: null,
    vehicles: null,
  },
  update: {
    services: null,
  },
  delete: {
    vehicles: null,
    services: null,
  },
  file: {},
  fixVehicles: [],
  importData: {},
  shortcutMO: {},
}

export const mutations = {
  SET_GROUP_NAME(state, payload) {
    state.serviceGroupName = payload
  },
  SET_VEHICLES(state, payload) {
    state.vehicles = payload
    state.add.vehicles = null
    state.delete.vehicles = null
  },
  SET_SERVICES(state, payload) {
    state.services = payload
    state.add.services = null
    state.update.services = null
    state.delete.services = null
  },
  SET_FIX_VEHICLES(state, payload) {
    state.fixVehicles = payload
  },
  RESET_FIX_VEHICLES(state) {
    state.fixVehicles.splice(0, state.fixVehicles.length)
  },
  ADD_VEHICLE(state, payload) {
    state.add.vehicles = payload
  },
  ADD_SERVICE(state, payload) {
    state.fixVehicles = payload.vehicles
    state.add.services = payload.serviceInput
    state.update.services = null
  },
  UPDATE_SERVICE(state, payload) {
    state.update.services = payload
    state.add.services = null
  },
  DELETE_VEHICLE(state, payload) {
    state.delete.vehicles = payload
  },
  DELETE_SERVICES(state, payload) {
    state.delete.services = payload
  },
  RESET_VEHICLES_SERVICES(state) {
    state.serviceGroupName = ''
    state.services = []
    state.vehicles = []
    state.add = {
      services: null,
      vehicles: null,
    }
    state.update = {
      services: null,
    }
    state.delete = {
      vehicles: null,
      services: null,
    }
  },
  SET_FILE(state, payload) {
    state.file = payload
  },
  SET_IMPORT_RESULT(state, payload) {
    state.importData = payload
  },
  SET_SHORTCUT_MO(state, payload) {
    state.shortcutMO = payload
  },
}
